import { render, staticRenderFns } from "./home_upload_picture.vue?vue&type=template&id=6c48a716&scoped=true"
import script from "./home_upload_picture.vue?vue&type=script&lang=js"
export * from "./home_upload_picture.vue?vue&type=script&lang=js"
import style0 from "./home_upload_picture.vue?vue&type=style&index=0&id=6c48a716&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c48a716",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/yunxiao/be-3sdnltdmmjqei95chipgpfz5/runner/__flow_work/__flow_builds/182a3969-2a32-4dff-94d8-cf1bbedf203a/workspace/crmeb-mer-admin_BNnv/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6c48a716')) {
      api.createRecord('6c48a716', component.options)
    } else {
      api.reload('6c48a716', component.options)
    }
    module.hot.accept("./home_upload_picture.vue?vue&type=template&id=6c48a716&scoped=true", function () {
      api.rerender('6c48a716', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/maintain/components/mobileFormPage/home_upload_picture.vue"
export default component.exports